// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"u3-z","displaySixCardTiles":"v3-z"};